const DEFAULT_REST_BASE = "https://ws.appclientefiel.com.br/rest/"
const AMPLIFY_REST_BASE = "https://preproducao.appclientefiel.com.br/rest/"

/**
 * URL base dos webservices REST (com barra final em /rest/).
 * Ordem: localStorage "teste" (override manual); host com "amplify" → pré-produção; senão produção.
 */
export function getRestApiBaseUrl() {
    try {
        const teste = localStorage.getItem("teste")
        if (teste && String(teste).trim()) return teste
    } catch {
        /* ignore */
    }
    if (typeof window !== "undefined") {
        const href = window.location.href || ""
        if (href.toLowerCase().includes("amplify")) return AMPLIFY_REST_BASE
    }
    return DEFAULT_REST_BASE
}
